import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import Footer from '@/components/Footer';

const FONT = '"Inter", system-ui, -apple-system, sans-serif';

const PrivacyPage: React.FC = () => (
  <Box sx={{ bgcolor: 'white', fontFamily: FONT }}>
    {/* ─── Hero ───────────────────────────────────────────────── */}
    <Box sx={{ py: { xs: 10, md: 14 }, position: 'relative', overflow: 'hidden' }}>
      <Box sx={{
        position: 'absolute', inset: 0, zIndex: 0,
        background: `
          radial-gradient(ellipse 80% 60% at 50% 30%, rgba(16,185,129,0.06) 0%, transparent 60%),
          linear-gradient(to bottom, #fafbfc 0%, white 100%)
        `,
      }} />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontFamily: FONT, fontWeight: 800,
            fontSize: { xs: '2.2rem', md: '3rem' },
            lineHeight: 1.1, letterSpacing: '-0.03em',
            color: '#0f172a', mb: 2,
          }}
        >
          Privacy Policy
        </Typography>
        <Typography sx={{
          fontFamily: FONT, fontSize: '1rem',
          color: 'text.secondary',
        }}>
          Last updated: April 2026
        </Typography>
      </Container>
    </Box>

    {/* ─── Content ────────────────────────────────────────────── */}
    <Container maxWidth="md" sx={{ pb: { xs: 10, md: 14 } }}>
      <Box sx={{
        '& h2': { fontFamily: FONT, fontWeight: 700, fontSize: '1.4rem', color: '#0f172a', mt: 5, mb: 2 },
        '& p': { fontFamily: FONT, fontSize: '1rem', color: 'text.secondary', lineHeight: 1.8, mb: 2 },
      }}>
        <Typography component="h2">Overview</Typography>
        <Typography component="p">
          Player Central ("we", "us", or "our") is operated by Eleventh Triangular.
          This Privacy Policy describes how we collect, use, and protect your personal information when you use our service.
        </Typography>

        <Typography component="h2">Information We Collect</Typography>
        <Typography component="p">
          We collect information you provide directly, including your name, email address, and player/team information you
          enter into the service. We also collect usage data such as pages visited and features used to improve the product.
        </Typography>

        <Typography component="h2">How We Use Your Information</Typography>
        <Typography component="p">
          We use your information to provide and improve the Player Central service, send you relevant notifications about
          your schedules, and communicate with you about your account. We do not sell your personal information to third parties.
        </Typography>

        <Typography component="h2">Data Storage &amp; Security</Typography>
        <Typography component="p">
          Your data is stored securely and we use industry-standard measures to protect it. We use encryption in transit and
          at rest to safeguard your information.
        </Typography>

        <Typography component="h2">Third-Party Services</Typography>
        <Typography component="p">
          We may use third-party services such as mapping providers and email delivery services to operate the product.
          These services process data only as necessary to perform their function on our behalf.
        </Typography>

        <Typography component="h2">Your Rights</Typography>
        <Typography component="p">
          You can access, update, or delete your personal information at any time through your account settings.
          If you have questions about your data, please contact us.
        </Typography>

        <Typography component="h2">Contact</Typography>
        <Typography component="p">
          If you have any questions about this Privacy Policy, please contact us at eleventhtriangular@gmail.com.
        </Typography>
      </Box>
    </Container>

    <Footer />
  </Box>
);

export default PrivacyPage;
